import Http from './http'

export default {
  account: {
    register (data) {
      return Http.post({ url: '/api/account/register', data: data })
    },
    registerVisitor (data) {
      return Http.post({ url: '/api/account/registerVisitor', data: data })
    },
    login (data) {
      return Http.post({ url: '/api/account/login', data: data })
    },
    logout (data) {
      return Http.post({ url: '/api/account/logout', data: data })
    },
    resetPassword (data) {
      return Http.post({ url: '/api/account/resetPassword', data: data })
    },
    userInfo (data) {
      return Http.get({ url: '/api/account/getAccountInfo', data: data })
    }
  },

  game: {
    getBaseData (data) {
      return Http.get({ url: '/api/game/baseData', data: data })
    },
    getRecruitData (data) {
      return Http.get({ url: '/api/game/recruitData', data: data })
    },
    getRoleHeroes (data) {
      return Http.get({ url: '/api/game/arena/roleHeroes', data: data })
    },
    dismissRoom (data) {
      return Http.post({ url: '/api/game/dismissRoom', data: data })
    },
    getCryptLevels (data) {
      return Http.get({ url: '/api/game/crypt/getCryptLevels', data: data })
    },
    getNagaBankLevels (data) {
      return Http.get({ url: '/api/game/nagaBank/levels', data: data })
    },
    getDwarvenTreasury (data) {
      return Http.get({ url: '/api/game/dwarvenTreasury/levels', data: data })
    },
    getCyclopsStockpileLevels (data) {
      return Http.get({ url: '/api/game/cyclopsStockpile/levels', data: data })
    },
    getGriffinConservatoryLevels (data) {
      return Http.get({ url: '/api/game/GriffinConservatory/levels', data: data })
    },
    sceneMonolithTwoWay (data) {
      return Http.post({ url: '/api/game/scene/monolithTwoWay', data: data })
    },
  },

  task: {
    getTaskList (data) {
      return Http.get({ url: '/api/game/task/list', data: data })
    },
    receive (data) {
      return Http.post({ url: '/api/game/task/receive', data: data })
    },
  },

  hero: {
    getHeroInfo (data) {
      return Http.get({ url: '/api/hero/getHeroInfo', data: data })
    },
    getHeroLevelRank (data) {
      return Http.get({ url: '/api/hero/getHeroLevelRank', data: data })
    },
    getHeroWore (data) {
      return Http.get({ url: '/api/hero/getHeroWore', data: data })
    },
    getTroop (data) {
      return Http.get({ url: '/api/hero/getTroop', data: data })
    },
    getGold (data) {
      return Http.get({ url: '/api/hero/getGold', data: data })
    },
    getActionPoint (data) {
      return Http.get({ url: '/api/hero/getActionPoint', data: data })
    },
    getPrimarySkills (data) {
      return Http.get({ url: '/api/hero/getPrimarySkills', data: data })
    },
    getSecondarySkills (data) {
      return Http.get({ url: '/api/hero/getSecondarySkills', data: data })
    },
    getBackpackItems (data) {
      return Http.get({ url: '/api/hero/getBackpackItems', data: data })
    },
    updateTroop (data) {
      return Http.postJSON({ url: '/api/hero/updateTroop', data: data })
    },
    addPrimarySkill (data) {
      return Http.post({ url: '/api/hero/addPrimarySkill', data: data })
    },
    updateSecondarySkills (data) {
      return Http.postJSON({ url: '/api/hero/updateSecondarySkills', data: data })
    },
    useBackpackItem (data) {
      return Http.post({ url: '/api/hero/useBackpackItem', data: data })
    },
    unwield (data) {
      return Http.post({ url: '/api/hero/unwield', data: data })
    },
    setNecromancy (data) {
      return Http.postJSON({ url: '/api/hero/setNecromancy', data: data })
    },
    getReputation (data) {
      return Http.get({ url: '/api/hero/reputation', data: data })
    },
  },

  pkConfig: {
    getFreeModeConfigList (data) {
      return Http.get({ url: '/api/pkConfig/freeModeConfigList', data: data })
    },
    getPublicFreeModeConfigList (data) {
      return Http.get({ url: '/api/pkConfig/publicFreeModeConfigList', data: data })
    },
    addFreeModeConfig (data) {
      return Http.post({ url: '/api/pkConfig/addFreeModeConfig', data: data })
    },
    updateFreeModeConfig (data) {
      return Http.post({ url: '/api/pkConfig/updateFreeModeConfig', data: data })
    },
    deleteFreeModeConfig (data) {
      return Http.post({ url: '/api/pkConfig/deleteFreeModeConfig', data: data })
    },
    shareFreeModeConfig (data) {
      return Http.post({ url: '/api/pkConfig/shareFreeModeConfig', data: data })
    },
  },

  playground: {
    getRank (data) {
      return Http.get({ url: '/api/playground/rank', data: data })
    },
    updateRecord (data) {
      return Http.post({ url: '/api/playground/updateRecord', data: data })
    },
  },

  forgingFactory: {
    getSynthesisList (data) {
      return Http.get({ url: '/api/game/forgingFactory/synthesisList', data: data })
    },
    forge(data) {
      return Http.post({ url: '/api/game/forgingFactory/forge', data: data })
    },
    treasureUpgrade(data) {
      return Http.post({ url: '/api/game/forgingFactory/treasure/upgrade', data: data })
    },
  },

  shop: {
    getCargoList (data) {
      return Http.get({ url: '/api/shop/cargoList', data: data })
    },
    buy (data) {
      return Http.postJSON({ url: '/api/shop/buy', data: data })
    },
    exchangeList (data) {
      return Http.get({ url: '/api/shop/exchangeList', data: data })
    },
    exchange (data) {
      return Http.postJSON({ url: '/api/shop/exchange', data: data })
    },
  },

  moshiShop: {
    getList (data) {
      return Http.get({ url: '/api/moshiShop/list', data: data })
    },
    buy (data) {
      return Http.postJSON({ url: '/api/moshiShop/buy', data: data })
    },
  },

  market: {
    getSellList (data) {
      return Http.get({ url: '/api/market/sellList', data: data })
    },
    getSaleableList (data) {
      return Http.get({ url: '/api/market/saleableList', data: data })
    },
    getUserSellList (data) {
      return Http.get({ url: '/api/market/userSellList', data: data })
    },
    buy (data) {
      return Http.postJSON({ url: '/api/market/buy', data: data })
    },
    sell (data) {
      return Http.postJSON({ url: '/api/market/sell', data: data })
    },
    cancelSell (data) {
      return Http.postJSON({ url: '/api/market/cancelSell', data: data })
    },
    extractGold (data) {
      return Http.postJSON({ url: '/api/market/extractGold', data: data })
    },

    // 收购
    getRequestPurchaseList (data) {
      return Http.get({ url: '/api/market/requestPurchaseList', data: data })
    },
    publishRequestPurchase (data) {
      return Http.postJSON({ url: '/api/market/publishRequestPurchase', data: data })
    },
    sellForRequestPurchase (data) {
      return Http.postJSON({ url: '/api/market/sellForRequestPurchase', data: data })
    },
    getUserRequestPurchaseList (data) {
      return Http.get({ url: '/api/market/userRequestPurchaseList', data: data })
    },
    extractRequestPurchaseArtifact(data) {
      return Http.postJSON({ url: '/api/market/extractRequestPurchaseArtifact', data: data })
    },
    cancelRequestPurchase (data) {
      return Http.postJSON({ url: '/api/market/cancelRequestPurchase', data: data })
    },
  },

  town: {
    getTowns (data) {
      return Http.get({ url: '/api/town/getTowns', data: data })
    },
    setInitialTown (data) {
      return Http.post({ url: '/api/town/setInitialTown', data: data })
    },
    createTown (data) {
      return Http.post({ url: '/api/town/createTown', data: data })
    },
    upgrade (data) {
      return Http.post({ url: '/api/town/upgrade', data: data })
    },
    rebuild (data) {
      return Http.post({ url: '/api/town/rebuild', data: data })
    },
  },

  smsCode: {
    send (data) {
      return Http.post({ url: '/api/smsCode/send', data: data })
    }
  },

  system: {
    specialTheme (data) {
      return Http.get({ url: '/api/system/specialTheme', data: data })
    },
    getVersion (data) {
      return Http.get({ url: '/api/system/getVersion', data: data })
    },
  }
}
